import { NgModule } from '@angular/core';
import {
    AdvancedSelectFolderComponent,
    BreadcrumbComponent, CfnEcmItemListComponent,
    CfnEcmItemGridComponent,
    CfnEcmItemDetailsComponent,
    CfnEcmDownloadButtonComponent,
    CfnEcmSelectionDetailsComponent,
    SelectFolderComponent,
    SelectSortComponent,
    SelectSpaceComponent,
    ViewModeButtonComponent, NotificationsComponent, MetaDataFormComponent, DateInputComponent
} from './components';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogComponent, FolderDetailsDialogComponent, RenameDocumentsComponent, SessionExpiredDialogComponent, UpdateNoticeDialogComponent } from './dialogs';
import { AddDocumentFolderDialogComponent } from './dialogs';
import { SharedModule, SmexLibCommonFrontendModule } from '@numen/smex-lib-common-frontend';
import { CfnEcmItemIconComponent } from './components';
import { LibCfnEcmCoreModule } from '../core/core.module';
import { AddMetaDataComponent } from './dialogs/add-metadata/add-metada.component';
import { FileSizePipe } from './pipes/file-size.pipe';
import { EditCustomMetadatasComponent } from './dialogs/edit-custom-metadatas/edit-custom-metadatas.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { ApiService } from './services/api/api.service';
import { NumbersWithSpacePipe } from './pipes/numbers-with-space.pipe';


@NgModule({
    declarations: [
        CfnEcmItemIconComponent,
        CfnEcmItemListComponent,
        CfnEcmItemGridComponent,
        BreadcrumbComponent,
        CfnEcmItemDetailsComponent,
        CfnEcmDownloadButtonComponent,
        CfnEcmSelectionDetailsComponent,
        FolderDetailsDialogComponent,
        ConfirmDialogComponent,
        ViewModeButtonComponent,
        SelectSpaceComponent,
        SelectSortComponent,
        SelectFolderComponent,
        AdvancedSelectFolderComponent,
        AddDocumentFolderDialogComponent,
        NotificationsComponent,
        MetaDataFormComponent,
        DateInputComponent,
        AddMetaDataComponent,
        FileSizePipe,
        NumbersWithSpacePipe,
        EditCustomMetadatasComponent,
        FooterComponent,
        RenameDocumentsComponent,
        SessionExpiredDialogComponent,
        UpdateNoticeDialogComponent
    ],
    imports     : [
        SmexLibCommonFrontendModule,
        ReactiveFormsModule,
        SharedModule,
        LibCfnEcmCoreModule,
        RouterModule
    ],
    exports     : [
        SmexLibCommonFrontendModule,
        SharedModule,
        CfnEcmItemIconComponent,
        CfnEcmItemListComponent,
        CfnEcmItemGridComponent,
        BreadcrumbComponent,
        CfnEcmItemDetailsComponent,
        CfnEcmDownloadButtonComponent,
        CfnEcmSelectionDetailsComponent,
        FolderDetailsDialogComponent,
        ConfirmDialogComponent,
        ViewModeButtonComponent,
        SelectSortComponent,
        SelectSpaceComponent,
        SelectFolderComponent,
        NotificationsComponent,
        MetaDataFormComponent,
        DateInputComponent,
        FileSizePipe,
        NumbersWithSpacePipe,
        EditCustomMetadatasComponent,
        FooterComponent,
        RenameDocumentsComponent,
        SessionExpiredDialogComponent,
        UpdateNoticeDialogComponent
    ],
    providers: [ApiService]
})
export class LibCfnEcmSharedModule {
}
